import { render } from "./IconWaterDrop.vue?vue&type=template&id=38c915b0"
import script from "./IconWaterDrop.vue?vue&type=script&lang=js"
export * from "./IconWaterDrop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__